export const PLANNING_TIME_CONTROLS_WIDGET_NAMESPACE = 'widget.planning-time-controls'
